import { Controller } from "@hotwired/stimulus"
import Handlebars from "handlebars"
import BaseGrid, { html } from "../utils/base_grid"

const nameTemplate = Handlebars.compile(`
  <a href="{{content.view_url}}" data-turbo-frame="_top"><strong>{{content.name}}</strong></a>
`)

const typeBadgeTemplate = Handlebars.compile(`
  <span class="badge badge-type">{{content.type}}</span>
`)

const languageBadgeTemplate = Handlebars.compile(`
  <span class="badge badge-{{content.language}}">{{content.language}}</span>
`)

const actionsTemplate = Handlebars.compile(`
  <div class="action-buttons">
    <a href="{{content.view_url}}" class="btn btn-sm btn-secondary" data-turbo-frame="_top">View</a>
    <a href="{{remove_url}}" class="btn btn-sm btn-danger" data-turbo-method="delete" data-turbo-confirm="Remove from favorites?">Remove</a>
  </div>
`)

export default class extends Controller {
  static values = { url: String }
  static targets = ["container", "skeleton"]

  connect() {
    this.baseGrid = new BaseGrid(this, {
      limit: 20,
      columns: [
        { 
          name: "Name", 
          formatter: (cell, row) => html(nameTemplate(row.cells[0].data))
        },
        { 
          name: "Type", 
          formatter: (cell, row) => html(typeBadgeTemplate(row.cells[0].data))
        },
        { 
          name: "Language", 
          formatter: (cell, row) => html(languageBadgeTemplate(row.cells[0].data))
        },
        { 
          name: "Added", 
          id: "created_at",
          formatter: (cell) => new Date(cell).toLocaleDateString()
        },
        { 
          name: "Actions", 
          sort: false,
          formatter: (cell, row) => html(actionsTemplate(row.cells[0].data))
        }
      ],
      mapData: (favorite) => [
        favorite, // Pass the whole object to the first cell
        favorite.content.type,
        favorite.content.language,
        favorite.created_at,
        null
      ],
      className: {
        table: 'table table-striped table-hover',
        thead: 'table-light',
        th: '',
        td: '',
        footer: ''
      }
    })
    
    this.grid = this.baseGrid.create()
  }

  disconnect() {
    this.baseGrid.destroy()
  }
}
